// eslint-disable-next-line no-use-before-define
import { Icon, mediaQueries, palette } from '@centivo/react-components'
import React from 'react'

import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'

import { GetProvidersSearch } from 'src/api/types'
import { useMediaContext } from 'src/context/responsive'
import { useResultsState } from 'src/context/results'
import { SearchResultsCounter } from 'src/refactor/components'
import { SearchBarForm } from 'src/refactor/components/SearchBarForm'
import { CATEGORY } from 'src/refactor/helpers/constants'
import { Content, ContentSection } from 'src/refactor/structure'
import { useSliceTemplate } from 'src/context/global'

const Container = styled(Content)<{ isListEmpty: boolean }>`
  flex: 0;

  ${({ theme }) => {
    switch (theme.template) {
      case 'template-4':
        return {
          backgroundColor: theme.palette.brand.beige,
          borderBottom: `1px solid ${theme.palette.brand.lightPurple}`,
        }
      default:
        return {
          backgroundColor: theme.palette.neutral['grey-f6f7fa'],
          boxShadow: '0px -1px 0px #ececec, 0px 1px 0px #ececec',
        }
    }
  }}

  section {
    padding-bottom: 1rem !important;

    @media ${mediaQueries.desktop} {
      padding-bottom: 2rem !important;
    }

    @media ${mediaQueries.iphone} {
      padding-bottom: ${props =>
        props.isListEmpty ? '0px !important' : '1rem !important'};
    }
  }
`
const StyledLink = styled(Link)`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 1rem 0;
  color: ${palette.neutral['primary-body']};
  width: fit-content;

  svg {
    margin-right: 0.5rem;
  }

  ${({ theme }) => {
    switch (theme.template) {
      case 'template-4':
        return css`
          font-weight: 400;
          font-size: 1.5rem;
          color: ${theme.palette.brand.darkGray};
          margin-left: 0;

          @media ${theme.mediaQueries.desktop} {
            margin-left: -2rem;
          }
        `
      default:
        return {
          fontWeight: 600,
          fontSize: '1.125rem',
          color: theme.palette.neutral['primary-body'],
        }
    }
  }}
`

export const ResultsHeader: React.FC = () => {
  const [state, actions] = useResultsState()
  const { isMobileView } = useMediaContext()

  const isListEmpty = state.displayItems?.length === 0

  const onSubmit = ({
    name,
    serviceLines,
    placeId,
    addressLabel,
  }: GetProvidersSearch) => {
    actions?.search({
      search: {
        name,
        serviceLines,
        placeId,
        addressLabel,
      },
    })
  }

  const isSliceTemplate = useSliceTemplate()
  const arrowColor = isSliceTemplate ? '#44190A' : palette.ui.blue

  return (
    <Container isListEmpty={isListEmpty}>
      <ContentSection>
        <StyledLink to="/" aria-label="Tap to go back to the previous page">
          <Icon
            icon="arrow-left"
            color={arrowColor}
            size="1.5rem"
            aria-hidden
          />
          {state.category === CATEGORY.DOCTOR ? 'Doctor' : 'Facility'}
        </StyledLink>
        <SearchBarForm
          category={state.category}
          onSubmit={onSubmit}
          defaultValues={state.search}
        />
        {isMobileView &&
          !state.isLoading &&
          (!isListEmpty || state.isRequestCanceled) && <SearchResultsCounter />}
      </ContentSection>
    </Container>
  )
}
